import { render } from "./choiceQuarter.vue?vue&type=template&id=d585e6ca&scoped=true"
import script from "./choiceQuarter.vue?vue&type=script&lang=js"
export * from "./choiceQuarter.vue?vue&type=script&lang=js"

import "./choiceQuarter.vue?vue&type=style&index=0&id=d585e6ca&scoped=true&lang=css"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d585e6ca"]])

export default __exports__